import { message } from 'antd';
import { createAsyncAction } from 'react-redux-await-control';
import { telli } from '~/services';

export const getDeeplink = createAsyncAction('FORMALIZATION_GET_DEEPLINK', {
  initialValue: [],
  saveResult: true,
  context: {
    onRequestError: () => message.error('Erro ao criar deeplink'),
    errorParser: () => [],
    responseParser: ({ data }) => {
      const { content, ...pagination } = data;
      return { contracts: content, pagination };
    },
    request: ({ document, contractId }) =>
      telli.post('/admin/personcustom/people/opportunities/deeplink', {
        document,
        contractId,
        origin: 'DEEPLINK_BACKOFFICE',
      }),
  },
});

export const getBankAccount = createAsyncAction('FORMALIZATION_GET_BANK_ACCOUNT', {
  initialValue: [],
  saveResult: true,
  context: {
    onRequestError: () => {},
    errorParser: () => [],
    responseParser: ({ data }) => data.resource,
    request: ({ document }) =>
      telli.get('/admin/formalizationcustom/bank', {
        params: { document },
      }),
  },
});

export const updateBankAccount = createAsyncAction('FORMALIZATION_UPDATE_BANK_ACCOUNT', {
  initialValue: [],
  saveResult: true,
  context: {
    onRequestError: () => {},
    errorParser: () => [],
    responseParser: ({ data }) => data.resource,
    request: ({ document, bankAccount }) =>
      telli.put('/admin/formalizationcustom/bank', bankAccount, { params: { document } }),
  },
});

export const getAvailableBanks = createAsyncAction('FORMALIZATION_GET_AVAILABLE_BANKS', {
  initialValue: [],
  saveResult: true,
  context: {
    onRequestError: () => {},
    errorParser: () => [],
    responseParser: ({ data }) => data.resource,
    request: ({ enrollmentId, contractId }) =>
      telli.get('/admin/formalizationcustom/banksavailablefordeposit', {
        params: {
          enrollmentId,
          contractId,
        },
      }),
  },
});

export const updateAddress = createAsyncAction('FORMALIZATION_UPDATE_ADDRESS', {
  context: {
    onRequestError: () => {},
    responseParser: ({ data }) => data.resource,
    request: (address) => telli.put('/admin/formalizationcustom/address', address),
  },
});

export const updateAddressGroup = createAsyncAction('FORMALIZATION_UPDATE_ADDRESS_GROUP', {
  context: {
    onRequestError: () => {},
    responseParser: ({ data }) => data.resource,
    request: (address) => telli.put('/admin/formalizationcustom/address/groupprocess', address),
  },
});

export const acceptTerms = createAsyncAction('FORMALIZATION_ACCEPT_TERMS', {
  context: {
    onRequestError: () => {},
    responseParser: ({ data }) => data.resource,
    request: (data) => telli.post('/admin/formalizationcustom/acceptdetailandterms', data),
  },
});

export const acceptTermsGroup = createAsyncAction('FORMALIZATION_ACCEPT_TERMS_GROUP', {
  context: {
    onRequestError: () => {},
    responseParser: ({ data }) => data.resource,
    request: (data) => telli.post('/admin/formalizationcustom/groupprocess/acceptdetailandterms', data),
  },
});
